import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import {
	SAL6030_R01DetailDto,
	SAL6030_R01Filter,
	SAL6030_R01GroupDto,
	SAL6030_R01HeaderDto,
} from "./Dto_SAL6030_R01";

const baseUrl = `${config.apiUrl}/SAL6030_R01`;

export const getSAL6030_R01HeaderList = (
	option: string,
	filter: SAL6030_R01Filter,
	listLength = 0
) =>
	getData<ResponseDto<SAL6030_R01HeaderDto[]>>(`${baseUrl}/${option}`, {
		params: {
			brandCd: filter.brandCd || undefined,
			itemCd: filter.itemCd || undefined,
			listLength,
		},
	});

export const getSAL6030_R01AllCount = (filter: SAL6030_R01Filter) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, {
		params: {
			brandCd: filter.brandCd || undefined,
			itemCd: filter.itemCd || undefined,
		},
	});

export const getSAL6030_R01GroupList = (itemCd: string) =>
	getData<ResponseDto<SAL6030_R01GroupDto[]>>(`${baseUrl}/group/${encodeURIComponent(itemCd)}`);

export const getSAL6030_R01DetailList = (itemCd: string) =>
	getData<ResponseDto<SAL6030_R01DetailDto[]>>(`${baseUrl}/detail/${encodeURIComponent(itemCd)}`);
